module.exports = __webpack_public_path__ + "static/predictivepoem 11-01-bfc748cf8adf15b7389bcabd67650166.jpg";